import React from 'react';
import parser, { Template } from 'uri-template';

import { getMetaContent } from '../../../lib/dom';

import { useFileUpload } from './useFileUpload';

export type HandleFileChange = (newFile: File | undefined) => void;
type UseFileUpload = [handleFileChange: HandleFileChange, progress: number | undefined, preview: string | undefined];

const previewUrl = (iriTemplate: Template | undefined, inputValue: string | undefined): string | undefined => {
  if (!inputValue || !iriTemplate) {
    return undefined;
  }

  return inputValue.includes('http') ? inputValue : iriTemplate.expand({ signed_id: inputValue });
};

const blogPreviewIRI = getMetaContent('blob-preview');

export const useFileInput = (
  inputValue: string | undefined,
  handleChange: (signedId: string) => void,
): UseFileUpload => {
  const blobPreviewUrl = blogPreviewIRI ? parser.parse(blogPreviewIRI) : undefined;
  const [uploadFile, progress] = useFileUpload();

  const handleFileChange = React.useCallback<HandleFileChange>(
    (newFile) => {
      if (newFile) {
        uploadFile(newFile, handleChange);
      } else {
        handleChange('');
      }
    },
    [handleChange],
  );

  const preview = previewUrl(blobPreviewUrl, inputValue);

  return [handleFileChange, progress, preview];
};
